<script>
  import PolicePara from './PolicePara.svelte';
  export let level;
  export let issueName;
  export let city;
  export let topic;
  export let content;
  export let inc;
  export let category;
  import { __ } from '../../../utils/i18n';

  let h;

  let limit = 200;
  let showAll = false;
  function onToggle() {
    showAll = !showAll;
  }

</script>

<div class="icard {level} {category}">
  <div class="header">
    <p class="label">{issueName}</p>
    {#if topic}
      <h4>{topic}</h4>
    {/if}
  </div>

  <div class="complex" class:show-more={showAll}>
    {#if category != 'police'}
      {@html content}
    {:else if level == 'county'}
      {@html content}
    {:else}
      <PolicePara {city} {inc} />
    {/if}

    <button class="showbtn btn action" on:click={onToggle}>
      {showAll ? __('Show less') : __('Show me more')}
    </button>
  </div>
</div>
